import classnames from 'classnames';
import Container from '@components/Container';
import styles from './Trustpilot.module.css';
import Head from 'next/head';
import Header from '@features/PageBuilder/components/Header';
import { HeaderSettings } from '@shared/types';

const { Root, Reviews } = styles;

interface TrustpilotProps {
  header: string;
  subheader?: string;
  headerSettings: HeaderSettings;
  widget: string;
}

const Trustpilot: React.FC<TrustpilotProps> = ({
  header,
  subheader,
  headerSettings = {},
  widget,
}) => {
  const classes = classnames(Root);

  if (!widget) return null;

  return (
    <Container className={classes}>
      <Head>
        <script
          type="text/javascript"
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          async
        ></script>
      </Head>

      <Header
        text={header}
        subheader={subheader}
        position="center"
        headerSettings={headerSettings}
      />

      {widget && (
        <div className={Reviews} dangerouslySetInnerHTML={{ __html: widget }} />
      )}
    </Container>
  );
};

export default Trustpilot;
